const SAMPLE_ENTRIES = [
  { id: "s1", date: "2026-05-12", project: "Acme — K8s migration",      task: "Helm chart cleanup",                hours: 3.5, notes: "" },
  { id: "s2", date: "2026-05-12", project: "Acme — K8s migration",      task: "PR review",                         hours: 1.0, notes: "" },
  { id: "s3", date: "2026-05-11", project: "Foundry — CI pipeline",     task: "GitHub Actions matrix",             hours: 4.0, notes: "" },
  { id: "s4", date: "2026-05-11", project: "Foundry — CI pipeline",     task: "Cache config tuning",               hours: 1.5, notes: "" },
  { id: "s5", date: "2026-05-10", project: "Internal — Tools platform", task: "AuthContext + ProtectedRoute",      hours: 2.5, notes: "" },
];

export default SAMPLE_ENTRIES;
